// https://stackoverflow.com/a/46181288
function getDocumentElement() {
    return document.scrollingElement || document.documentElement;
}

function getHeaderElement() {
    return document.getElementById('checkout-header');
}

// http://easings.net/
const easings = {
    linear: t => t,
    easeInQuad: t => t * t,
    easeOutQuad: t => t * (2 - t),
    easeInOutQuad: t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
    easeInCubic: t => t * t * t,
    easeOutCubic: t => --t * t * t + 1,
    easeInOutCubic: t => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
    easeInQuart: t => t * t * t * t,
    easeOutQuart: t => 1 - --t * t * t * t,
    easeInOutQuart: t => (t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t),
    easeInQuint: t => t * t * t * t * t,
    easeOutQuint: t => 1 + --t * t * t * t * t,
    easeInOutQuint: t => (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t),
};

/**
 * scroll to an element
 * @param el (node) - optional - default to the whole page.
 * @param options (object) - optional
 */
function scrollTo(el, options = {}) {
    const destination = options.destination || 'top';
    const behavior = options.behavior || 'easeOutQuad';
    const duration = options.duration || 1000;
    const callback = options.callback;
    const offset = options.offset || 0;

    const documentEl = getDocumentElement();
    const startTime = Date.now();
    const startPos = documentEl.scrollTop;
    let endPos;

    if (!el) {
        el = getDocumentElement();
    }
    if (destination === 'bottom') {
        endPos = startPos + el.getBoundingClientRect().bottom - window.innerHeight;
    } else {
        const header = getHeaderElement();
        endPos = header
            ? startPos + el.getBoundingClientRect().top - header.offsetHeight - offset
            : el.offsetTop;
    }
    endPos = endPos < 0 ? 0 : endPos;

    function scroll() {
        const currentTime = Date.now();
        const timeDiff = currentTime - startTime;
        const time = Math.min(1, timeDiff / duration);

        documentEl.scrollTop = startPos + easings[behavior](time) * (endPos - startPos);

        // base case
        if (timeDiff > duration) {
            if (callback) {
                callback();
            }
            return;
        }
        window.requestAnimationFrame(scroll);
    }
    scroll();
}

/**
 * scroll to the top of the page or an element.
 * @param el (node) optional - default to the whole page.
 * @param options (object) optional
 */
export function scrollToTop(el, options = {}) {
    scrollTo(el, {
        ...options,
        destination: 'top',
    });
}

/**
 * scroll to the bottom of the page or an element.
 * @param el (node) optional - default to the whole page.
 * @param options (object) optional
 */
export function scrollToBottom(el, options = {}) {
    scrollTo(el, {
        ...options,
        destination: 'bottom',
    });
}

export function isOffTop(el) {
    const { top = 0 } = (el && el.getBoundingClientRect()) || {};
    const checkout = document.getElementById('checkout');
    return top < checkout.offsetTop;
}

export function isOffBottom(el) {
    const { bottom = 0 } = (el && el.getBoundingClientRect()) || {};
    const viewportHeight = window.innerHeight;
    return bottom > viewportHeight;
}

export function isOffScreen(el) {
    return isOffTop(el) || isOffBottom(el);
}
